module.exports = __webpack_public_path__ + "img/FP.3a6a8f3c.png";